import * as R from 'ramda'
import { combineEpics, ofType } from 'redux-observable'
import * as Observable from 'rxjs'
import { filter, map, pluck, switchMap } from 'rxjs/operators'

import * as EmbedAPI from 'api/DefaultEmbedAPI'

import * as EmbedActions from './actions'

const updateEmbed = (action$) =>
  action$.pipe(
    ofType(EmbedActions.updateEmbed.toString()),
    pluck('payload'),
    map((properties) =>
      Object.entries(properties)
        .filter(([_, value]) => !R.isNil(value))
        .map(([key, value]) => ({
          operation: 'set',
          property: key,
          value: value,
        }))
    ),
    filter(R.complement(R.isEmpty())),
    switchMap((patchOperations) =>
      Observable.from(EmbedAPI.patchDefaultEmbed(patchOperations))
    ),
    map(({ data }) => EmbedActions.receiveEmbed(data))
  )

export default combineEpics(updateEmbed)
